var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_c('span', [_vm._v("주문내역")]), _c('v-spacer'), _c('span', [_vm._v("총 주문금액 "), _c('b', [_vm._v(_vm._s(_vm.summary.totalAmount.format()))]), _vm._v("원")])], 1), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders,
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")) + " ")];
      }
    }, {
      key: "item.order.totalAmount",
      fn: function fn(_ref2) {
        var _item$order, _item$order$totalAmou, _item$order$totalAmou2;

        var item = _ref2.item;
        return [_vm._v(" " + _vm._s((_item$order = item.order) === null || _item$order === void 0 ? void 0 : (_item$order$totalAmou = _item$order.totalAmount) === null || _item$order$totalAmou === void 0 ? void 0 : (_item$order$totalAmou2 = _item$order$totalAmou.format) === null || _item$order$totalAmou2 === void 0 ? void 0 : _item$order$totalAmou2.call(_item$order$totalAmou)) + "원 ")];
      }
    }])
  }), _c('v-divider'), _c('v-card-text', [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }